module.exports = __webpack_public_path__ + "img/1.-细节观赏法-天坛九龙柏（柏慧-摄）.5191fc94.jpg";